const initialState = {
    holiday: {
        name: '',
        holidayDate: '00/00/0000',
        holidayTypeId: 0,
        message: '',
        id: 0,
    },
    updating: false,
    updated: false,
    error: null,
    holiday_types: []
}

export function holidayReducer(state = initialState, action) {

    switch (action.type) {

        case "CREATE_HOLIDAY":
        case "FETCH_HOLIDAY":
        case "UPDATE_HOLIDAY": {
            return { ...state, updating: true, updated: false, error: null }
        }

        case "CREATE_HOLIDAY_REJECTED":
        case "FETCH_HOLIDAY_REJECTED":
        case "UPDATE_HOLIDAY_REJECTED": {
            return { ...state, updating: false, error: action.payload }
        }

        case "CREATE_HOLIDAY_FULFILLED":
        case "FETCH_HOLIDAY_FULFILLED":
        case "UPDATE_HOLIDAY_FULFILLED": {
            return { ...state, updating: false, updated: true, holiday: action.payload.data }
        }

        case "HOLIDAY_ERROR": {
            return { ...state, error: null }
        }

        case "RETRIEVE_HOLIDAY_TYPES": {
            return { ...state, updating: false, updated: true, holiday_types: action.payload.data }
        }

        default:
            return state
    }
}